import {
	availableMultipleText,
	availableSingleText,
	backorderDateText,
	backorderHasDaysText,
	bulkOrderStockNotifyClick,
	contactUsText,
	inStoreOnlyText,
	noBackorderText,
	noBackorderWithRestockText,
	notifyStockText,
	notPurchasableText,
	noWebOrderingText,
	outOfStockText,
	preorderText,
	prereleaseText,
} from '../store/orderingSlice';
import { useDispatch, useSelector } from 'react-redux';
import { availableTextHasDays, availableTextHasPlus } from '../utilities/product_utilities';
import classNames from 'classnames';
import { replaceTextDelimeterWithText } from '../utilities/language_utilities';

//Internal Use Message Sub Components
function BulkOrderNotifyLink({ notifyCode }) {
	const notify_link_text = useSelector(notifyStockText);
	const dispatch = useDispatch();
	return (
		<a
			className='notify_stock alert-link'
			href={'/notifystock.html?pcode=' + notifyCode}
			onClick={(e) => {
				e.preventDefault();
				dispatch(bulkOrderStockNotifyClick(notifyCode));
			}}
		>
			{notify_link_text}
		</a>
	);
}

function BulkOrderNoWebOrderingMessage() {
	const no_webordering_text = useSelector(noWebOrderingText);
	const contact_us_text = useSelector(contactUsText);
	return <span>{no_webordering_text} <a href="/SupportCenter/#ContactUs">{contact_us_text}</a>.</span>;
}

function BulkOrderPreReleaseMessage({ availableText }) {
	const prerelease_text = useSelector(prereleaseText);

	return <>{replaceTextDelimeterWithText(prerelease_text, availableText)}</>;
}

function BulkOrderNotPurchaseableMessage() {
	const not_purchasable_text = useSelector(notPurchasableText);

	return <>{not_purchasable_text}</>;
}

function BulkOrderInStoreOnly() {
	const instore_text = useSelector(inStoreOnlyText);

	return <>{instore_text}</>;
}

function BulkOrderPreOrderMessage({ availableText, notifyStock = false, notifyCode = '' }) {
	const preorder_text = useSelector(preorderText);

	return (
		<>
			<>{replaceTextDelimeterWithText(preorder_text, availableText)} </>
			{notifyStock && notifyCode && (
				<>
					<BulkOrderNotifyLink notifyCode={notifyCode} />.
				</>
			)}
		</>
	);
}

function BulkOrderAvailableMessage({ availableText }) {
	const is_singular = parseInt(availableText) === 1;
	const available_text = useSelector(is_singular ? availableSingleText : availableMultipleText);

	return <>{replaceTextDelimeterWithText(available_text, availableText)}</>;
}

function BulkOrderNoBackorderMessage({ availableText, notifyStock = false, notifyCode = '',  showRestockDate = false }) {
	const no_backorder_text = useSelector(noBackorderText);
	const no_backorder_with_restock_text = useSelector(noBackorderWithRestockText)

	return (
		<>
			<>
				{showRestockDate && availableText && !availableTextHasDays(availableText) && !availableTextHasPlus(availableText) ? 
				replaceTextDelimeterWithText(no_backorder_with_restock_text, availableText)
				: no_backorder_text}
			</>
			{notifyStock && notifyCode && (
				<>
					{" "}<BulkOrderNotifyLink notifyCode={notifyCode} />.
				</>
			)}
		</>
	);
}

function BulkOrderOutOfStockMessage() {
	const out_of_stock_text = useSelector(outOfStockText);

	return <>{out_of_stock_text}</>;
}

function BulkOrderBackorderMessage({ availableText, notifyStock = false, notifyCode = '' }) {
	const availableTextHasDaysBoolean = availableTextHasDays(availableText);
	const backorder_text = useSelector(availableTextHasDaysBoolean ? backorderHasDaysText : backorderDateText);

	if (availableTextHasDaysBoolean) {
		return <>{replaceTextDelimeterWithText(backorder_text, availableText)}</>;
	} else {
		if (availableText && !availableTextHasPlus(availableText)) {
			return (
				<>
					<>{replaceTextDelimeterWithText(backorder_text, availableText)} </>
					{notifyStock && notifyCode && (
						<>
							<BulkOrderNotifyLink notifyCode={notifyCode} />.
						</>
					)}
				</>
			);
		}
	}
}

function BulkOrderStockMessageWrapper({ children, hasSize = false, alertType = 'warning', messageStatus }) {
	const class_name = classNames({
		'bulk-drawer__alert': true,
		alert: true,
		'alert-warning': alertType === 'warning',
		'is-invalid': messageStatus === 'Invalid',
		'is-backordered': messageStatus === 'Backorder',
		'is-low-stock': messageStatus === 'LowStock',
	});

	return (
		<tr className='bulk-drawer__alert-row'>
			<td colSpan={hasSize ? 3 : 2}>
				<div className={class_name}>{children}</div>
			</td>
		</tr>
	);
}

export function BulkOrderStockMessage(props) {
	const valid_types = {
		PreRelease: BulkOrderPreReleaseMessage,
		NoWebOrdering: BulkOrderNoWebOrderingMessage,
		OutOfStock: BulkOrderOutOfStockMessage,
		NoBackorder: BulkOrderNoBackorderMessage,
		PreOrder: BulkOrderPreOrderMessage,
		Backorder: BulkOrderBackorderMessage,
		Available: BulkOrderAvailableMessage,
		NotPurchaseable: BulkOrderNotPurchaseableMessage,
		InStoreOnly: BulkOrderInStoreOnly,
	};

	if (props.messageType && typeof valid_types[props.messageType] !== 'undefined') {
		const MessageComponent = valid_types[props.messageType];

		const message_wrap_props = {};
		if (props.messageStatus) {
			message_wrap_props.messageStatus = props.messageStatus;
		}

		return (
			<BulkOrderStockMessageWrapper hasSize={props.hasSize} {...message_wrap_props}>
				<MessageComponent {...props} />
			</BulkOrderStockMessageWrapper>
		);
	} else {
		return <></>;
	}
}
